// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Error Boundary Styles */
.error-boundary-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.error-boundary-content {
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 600px;
  width: 100%;
}

.error-icon {
  font-size: 4rem;
  margin-bottom: 20px;
  display: block;
}

.error-boundary-content h2 {
  color: #dc3545;
  margin-bottom: 15px;
  font-size: 1.8rem;
  font-weight: 600;
}

.error-boundary-content p {
  color: #6c757d;
  margin-bottom: 25px;
  font-size: 1.1rem;
  line-height: 1.5;
}

.error-details {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 25px;
  text-align: left;
}

.error-details summary {
  cursor: pointer;
  font-weight: 600;
  margin-bottom: 10px;
  color: #495057;
}

.error-details summary:hover {
  color: #007bff;
}

.error-info {
  font-size: 0.9rem;
  color: #495057;
}

.error-info strong {
  color: #212529;
}

.error-info pre {
  background: #f1f3f4;
  padding: 10px;
  border-radius: 4px;
  font-size: 0.8rem;
  color: #d63384;
  white-space: pre-wrap;
  word-break: break-word;
  margin-top: 10px;
  border: 1px solid #dee2e6;
}

.error-actions {
  margin-bottom: 20px;
}

.error-btn {
  margin: 0 5px;
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.95rem;
}

.error-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.btn-primary.error-btn {
  background-color: #007bff;
  color: white;
}

.btn-primary.error-btn:hover {
  background-color: #0056b3;
}

.btn-secondary.error-btn {
  background-color: #6c757d;
  color: white;
}

.btn-secondary.error-btn:hover {
  background-color: #545b62;
}

.error-id {
  color: #6c757d;
  font-size: 0.85rem;
  margin-top: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #dee2e6;
}

.error-id small {
  color: #6c757d;
  font-size: 0.75rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .error-boundary-content {
    padding: 20px;
    margin: 10px;
  }
  
  .error-icon {
    font-size: 3rem;
  }
  
  .error-boundary-content h2 {
    font-size: 1.5rem;
  }
  
  .error-btn {
    display: block;
    width: 100%;
    margin: 5px 0;
  }
}

/* Chunk Loading Fallback */
.chunk-loading-fallback {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  color: #666;
  font-style: italic;
  animation: pulse 1.5s infinite ease-in-out;
}

@keyframes pulse {
  0% { opacity: 0.6; }
  50% { opacity: 1; }
  100% { opacity: 0.6; }
}

/* Connection Issue UI Enhancements */
.error-boundary-actions {
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 20px;
}

.theme-button-outline {
  background: transparent;
  border: 1px solid currentColor;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.theme-button-outline:hover {
  background: rgba(255, 255, 255, 0.1);
}

.error-boundary-content p.theme-text-color-secondary {
  color: #888;
  font-size: 0.95rem;
  max-width: 80%;
  margin: 0 auto 25px;
}


/* Dark Theme Support */
.theme-bg-color .error-boundary-container {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
}

.theme-bg-color .error-boundary-content {
  background: #333;
  color: #fff;
}

.theme-bg-color .error-boundary-content h2 {
  color: #ff6b6b;
}

.theme-bg-color .error-boundary-content p {
  color: #ccc;
}

.theme-bg-color .error-details {
  background-color: #444;
  border-color: #555;
}

.theme-bg-color .error-info pre {
  background: #2a2a2a;
  border-color: #555;
  color: #ff8a80;
}

.theme-bg-color .error-id {
  background-color: #444;
  border-color: #555;
  color: #ccc;
}`, "",{"version":3,"sources":["webpack://./src/components/ErrorBoundary/ErrorBoundary.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,aAAa;EACf;AACF;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,KAAK,YAAY,EAAE;EACnB,MAAM,UAAU,EAAE;EAClB,OAAO,YAAY,EAAE;AACvB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;;AAGA,uBAAuB;AACvB;EACE,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb","sourcesContent":["/* Error Boundary Styles */\n.error-boundary-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 50vh;\n  padding: 20px;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n}\n\n.error-boundary-content {\n  background: white;\n  padding: 40px;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  max-width: 600px;\n  width: 100%;\n}\n\n.error-icon {\n  font-size: 4rem;\n  margin-bottom: 20px;\n  display: block;\n}\n\n.error-boundary-content h2 {\n  color: #dc3545;\n  margin-bottom: 15px;\n  font-size: 1.8rem;\n  font-weight: 600;\n}\n\n.error-boundary-content p {\n  color: #6c757d;\n  margin-bottom: 25px;\n  font-size: 1.1rem;\n  line-height: 1.5;\n}\n\n.error-details {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 15px;\n  margin-bottom: 25px;\n  text-align: left;\n}\n\n.error-details summary {\n  cursor: pointer;\n  font-weight: 600;\n  margin-bottom: 10px;\n  color: #495057;\n}\n\n.error-details summary:hover {\n  color: #007bff;\n}\n\n.error-info {\n  font-size: 0.9rem;\n  color: #495057;\n}\n\n.error-info strong {\n  color: #212529;\n}\n\n.error-info pre {\n  background: #f1f3f4;\n  padding: 10px;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  color: #d63384;\n  white-space: pre-wrap;\n  word-break: break-word;\n  margin-top: 10px;\n  border: 1px solid #dee2e6;\n}\n\n.error-actions {\n  margin-bottom: 20px;\n}\n\n.error-btn {\n  margin: 0 5px;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.95rem;\n}\n\n.error-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.btn-primary.error-btn {\n  background-color: #007bff;\n  color: white;\n}\n\n.btn-primary.error-btn:hover {\n  background-color: #0056b3;\n}\n\n.btn-secondary.error-btn {\n  background-color: #6c757d;\n  color: white;\n}\n\n.btn-secondary.error-btn:hover {\n  background-color: #545b62;\n}\n\n.error-id {\n  color: #6c757d;\n  font-size: 0.85rem;\n  margin-top: 20px;\n  padding: 15px;\n  background-color: #f8f9fa;\n  border-radius: 6px;\n  border: 1px solid #dee2e6;\n}\n\n.error-id small {\n  color: #6c757d;\n  font-size: 0.75rem;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .error-boundary-content {\n    padding: 20px;\n    margin: 10px;\n  }\n  \n  .error-icon {\n    font-size: 3rem;\n  }\n  \n  .error-boundary-content h2 {\n    font-size: 1.5rem;\n  }\n  \n  .error-btn {\n    display: block;\n    width: 100%;\n    margin: 5px 0;\n  }\n}\n\n/* Chunk Loading Fallback */\n.chunk-loading-fallback {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 40px;\n  color: #666;\n  font-style: italic;\n  animation: pulse 1.5s infinite ease-in-out;\n}\n\n@keyframes pulse {\n  0% { opacity: 0.6; }\n  50% { opacity: 1; }\n  100% { opacity: 0.6; }\n}\n\n/* Connection Issue UI Enhancements */\n.error-boundary-actions {\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.theme-button-outline {\n  background: transparent;\n  border: 1px solid currentColor;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.theme-button-outline:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.error-boundary-content p.theme-text-color-secondary {\n  color: #888;\n  font-size: 0.95rem;\n  max-width: 80%;\n  margin: 0 auto 25px;\n}\n\n\n/* Dark Theme Support */\n.theme-bg-color .error-boundary-container {\n  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);\n}\n\n.theme-bg-color .error-boundary-content {\n  background: #333;\n  color: #fff;\n}\n\n.theme-bg-color .error-boundary-content h2 {\n  color: #ff6b6b;\n}\n\n.theme-bg-color .error-boundary-content p {\n  color: #ccc;\n}\n\n.theme-bg-color .error-details {\n  background-color: #444;\n  border-color: #555;\n}\n\n.theme-bg-color .error-info pre {\n  background: #2a2a2a;\n  border-color: #555;\n  color: #ff8a80;\n}\n\n.theme-bg-color .error-id {\n  background-color: #444;\n  border-color: #555;\n  color: #ccc;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
